import { Link } from "react-router-dom";
import styled from "styled-components";

export const NewRequestContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 60% 40%;
    height: 100%;
    /* overflow-y: auto; */
  }
`;

export const NewRequestForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 2rem 4rem 0 0;
  gap: 6px;

  @media (max-width: 768px) {
    padding: 2rem 0;
  }
`;

export const NormalInputsFields = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: 640px) {
    display: grid;
    grid-template-columns: 20% 78%;
    grid-gap: 2%;
  }
`;

export const NormalInput = styled.input`
  border: 1px solid white;
  height: 38px;
  padding: 0px 10px;
  color: ${(props) => props.color && props.color};
  border-radius: 7px;

  &:focus {
    border-color: #dce6e6;
    outline: none;
  }

  &:hover {
    border-color: #dce6e6;
  }
`;

export const InputSearch = styled.input`
  width: 100%;
  border-radius: 0.3rem;
  outline: initial !important;
  box-shadow: initial !important;
  font-size: 0.8rem;
  padding: 0.7rem 0.75rem 0.65rem 0.75rem;
  line-height: 1.5;
  border: 1px solid #d7d7d7;
  background: #f5f5f5;
  color: #212121;
`;

export const TelephoneInput = styled.div`
  width: 100%;
  border: 1px solid white;
  border-radius: 7px;
  border-color: ${(props) => props.focus && "#dce6e6"};

  &:hover {
    border-color: #dce6e6;
  }
`;

export const AdjuntarArchivoDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const AdjuntarArchivo = styled.label`
  text-decoration: underline;
  color: #3948ff;
  display: flex;
  flex-direction: row;
  gap: 3px;
  cursor: pointer;
  font-weight: bolder;
`;

export const InputAndDisplayFile = styled.div`
  display: flex;
  gap: 2%;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 5px;
`;

export const ScreenShotInput = styled.input`
  border: 1px solid white;
  height: 100%;
  padding: 0px 8px;
  border-radius: 7px;

  &:focus {
    border-color: #dce6e6;
    outline: none;
  }
`;

export const DisplayedFileStyle = styled.div`
  width: 35%;
  height: auto;
  min-height: 45px;
  background: #3dea83;
  border: 1px solid #dce6e6;
  border-radius: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 8px 10px;
  gap: 8px;
  position: relative;

  .file-name {
    word-break: break-word;
    white-space: normal;
    flex: 1;
    font-size: 14px;
    line-height: 1.2;
  }

  .delete-icon {
    flex-shrink: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
  }
`;



export const SubmitButtons = styled.button`
  width: 6rem;
  height: 2.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #3948ff;
  border-radius: 7px;
  background-color: ${(props) => props.bg && props.bg};
  color: ${(props) => props.color && props.color};
  cursor: ${(props) => (props.disabled ? "wait" : "pointer")};
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};

  &:hover {
    background-color: ${(props) => props.hoverChange && props.color};
    color: ${(props) => props.hoverChange && props.bg};
  }

  &:focus {
    outline: none;
  }
`;

export const RelatedArticles = styled.div`
  background-color: white;

  @media (min-width: 768px) {
    width: 100%;
    overflow: hidden;
    /* height: 100%; */
    border-left: 1px solid #dce6e6;
    /* border-bottom: 1px solid #dce6e6; */
  }

  @media (max-width: 768px) {
    min-height: 100px;
    height: 100px;
  }
`;

export const RelatedArticlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
`;

export const VerTodos = styled(Link)`
  padding: 0.35rem 1rem;
  text-decoration: underline;
  border-radius: 7px;
  color: #3948ff;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 15px;
  border: 1px solid white;

  &:hover {
    text-decoration: none;
    background-color: #3948ff;
    border-color: #3948ff;
    color: white;
  }
`;

export const ErrorModalBtn = styled.button`
  border-radius: 6px;
  border: 1px solid;
  border-color: ${(props) => (props.bg ? props.bg : "#787878")};
  height: 45px;
  width: 175px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.bg ? props.bg : "transparent")};
  color: ${(props) => (props.bg ? "white" : "#787878")};
  outline: none;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;
